import styled from "styled-components";
import "../../styles/sass/Pages/_newDesign.scss";

export const Container = styled.div`
	width: 50%;
	height: 100%;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
	padding: 1rem 0;

	overflow-x: auto;

	@media only screen and (max-width: 900px) {
		width: 100%;
		overflow-x: unset;
		height: auto;
	}

	@media only screen and (max-width: 380px) {
		height: 40rem;
	}
`;

export const Content = styled.section`
	width: 27rem;
	font-family: "MetropolisRegular";
	padding: 1rem 0;

	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	gap: 2rem;

	@media only screen and (max-width: 900px) {
		width: 100%;
		max-width: 23rem;
		overflow-x: unset;
	}

	@media only screen and (max-width: 380px) {
		width: 85%;
	}
`;

export const Col = styled.div`
	display: flex;
	flex-direction: column;
`;

export const Row = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;
`;

export const ContainerRouter = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	height: 100vh;
	align-items: center;
	background: var(--neutral-stronger);

	@media only screen and (max-width: 900px) {
		flex-direction: column;
		background: var(--neutral-strongest);
	}
`;

export const FormGroupInput = styled.form`
	position: relative;
	width: 100%;
`;

export const Title = styled.div`
	color: #ffffff;
	font-size: 24px;
	font-family: var(--font-family-metropolis-semi-bold);
	width: 100%;
`;

export const Subtitle = styled.span`
	font-size: 1rem;
	color: #ffffff;
	font-family: "MetropolisRegular";
	font-weight: 600;
`;

export const Description = styled.span`
	font-size: 0.875rem;
	color: #ffffff;
	font-family: "MetropolisRegular";
	font-weight: 600;
`;

export const FormSubmit = styled.div`
	width: 100%;
`;

export const Group = styled.div`
	cursor: pointer;
	display: flex;
	width: 25.5rem;
	align-items: center;
	justify-content: space-between;

	span {
		font-size: var(--font-size-huge);
		color: var(--neutral-smoothest);
	}

	@media only screen and (max-width: 900px) {
		align-items: flex-start;
		width: 100%;
	}
`;

export const ButtonTerms = styled.a`
	border: none;
	font-family: var(--font-family-metropolis-semi-bold);
	outline: none !important;
	font-size: 16px;
	color: #01e59b;

	:hover {
		color: #01e59b;
	}
`;
